import React, { Component } from "react";

// Libraries
import { motion } from "framer-motion";

// Router
import { withRouter } from "react-router-dom";

// SCSS
import "./ShoveBerryHome.scss";

//Components
import ShoveberryLevelGrid from "components/Shoveberry/ShoveberryLevelGrid";
import ShoveberryLevelsLayoutControlPanelResponsive from "components/Shoveberry/ShoveberryLevelsLayoutControlPanelResponsive";
import ShoveberryModal from "components/Shoveberry/ShoveberryModal";

// Constants
import { SHOVEBERRY_LEVELS_DATA } from "utils/constants";
import { storage } from "services/config/storage";

class ShoveBerryHome extends Component {
  gridComponent = React.createRef();

  state = {
    showModal: false,
    showLevelModal: false,
    isMobileView: false,
    modalData: {
      overlayColor: "#ff6262",
      thumbnail: "",
      title: "Oops!",
      timeTaken: "4:30",
      totalMoves: "30",
      subTitle: "You did better than 43% players",
      showPlayAgain: true,
      actionButtonText: "EXPLORE MORE GAMES",
      actionButtonRedirect: "/",
      showTimeSection: true,
    },
    currentLevel: 0,
  };

  componentDidMount() {
    if (window && window.innerWidth < 1023) {
      this.setState({
        isMobileView: true,
      });
    }

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    this.gridComponent.current.reset();
  }

  getMainContainerHeight() {
    if (!this.state.isMobileView) {
      return "calc(100vh - 65px)";
    } else {
      let controlPanel = document.querySelector(
        ".shoveberry-level-layout__control-panel-container"
      );
      let controlPanelHeight = controlPanel ? controlPanel.clientHeight : 0;
      return `calc(100vh - ${controlPanelHeight + 65}px)`;
    }
  }

  showTimeOutModal() {
    this.setState({
      showModal: true,
      modalData: {
        overlayColor: "#ff6262",
        thumbnail: "",
        title: "Oops!",
        timeTaken: "4:30",
        totalMoves: "30",
        subTitle: "You did better than 43% players",
        showPlayAgain: false,
        actionButtonText: "NEXT GAME",
        actionButtonRedirect: "/shoveberry",
        showTimeSection: true,
        // onPlayAgainClicked: this.replayLevelMethod(),
      },
    });
  }

  showSuccessModal() {
    this.setState({
      showModal: true,
      modalData: {
        overlayColor: "rgba(0, 0, 0, 0.3)",
        showTimeSection: false,
        showPlayAgain: false,
        actionButtonText: `Start Level ${this.state.currentLevel + 1} ->`,
        title: "Awesome",
        subTitle: "You got more berries to shove",
        thumbnail: this.getSuccessModalThumbnail(this.state.currentLevel),
        actionButtonRedirect: `/shoveberry/level`,
      },
    });
  }

  getSuccessModalThumbnail(level = 0) {
    return (
      <div className="shoveberry-modal__thumbnail-container">
        {level === 0 ? (
          <div className="shoveberry-modal__thumbnail-container--level-party"></div>
        ) : (
          <div className="shoveberry-modal__thumbnail-container--level-hexagon">
            {level}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { showModal, showLevelModal, isMobileView, modalData, currentLevel } =
      this.state;
    const gameDetails = storage.get.gameDetails();

    return (
      <>
        <div className="shoveberry-home-page">
          <motion.div
            initial={{ top: "40%", x: "-50%", scale: 0, opacity: 0 }}
            animate={{
              top: ["40%", "40%", "40%", "40%", "10.5%"],
              x: ["-50%", "-50%"],
              scale: [0, 1, 1.5, 1.5, 1],
              opacity: [0, 1, 1],
            }}
            transition={{
              duration: 3,
              delay: 0,
            }}
            className="shoveberry-home-page__title"
          >
            {gameDetails?.mediaUrl ? (
              <img src={gameDetails?.mediaUrl} alt="" className="" />
            ) : (
              <>
                <p className="shoveberry-home-page__title--text">Shove</p>
                <p className="shoveberry-home-page__title--text-active">
                  Berry
                </p>
              </>
            )}
            {gameDetails?.organizationName && (
              <p className="shoveberry-home-page__title--text">
                Powered by{" "}
                <span style={{ fontWeight: "700" }}>
                  {gameDetails.organizationName}
                </span>
              </p>
            )}
          </motion.div>
          <motion.div
            className="shoveberry-home-page__main-container"
            style={{ height: this.getMainContainerHeight() }}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 1,
              delay: 3.5,
            }}
          >
            <div className="shoveberry-home-page__level-grid-container">
              <ShoveberryLevelGrid
                onLevelComplete={() => this.showSuccessModal()}
                currentLevel={currentLevel}
                board={SHOVEBERRY_LEVELS_DATA[currentLevel]}
                ref={this.gridComponent}
              />
            </div>
            <p className="shoveberry-home-page__sub-title">
              Yellow tile is pusher tile. You can move it using keyboard
              commands. Use the yellow tile to push around the red tiles and
              send them home (marked with x)!
            </p>
          </motion.div>
          <motion.div
            className="shoveberry-home-page__control-panel-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 1,
              delay: 3.5,
            }}
          >
            <ShoveberryLevelsLayoutControlPanelResponsive
              showOnlyMoves={true}
              onMoveUp={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 38 })
              }
              onMoveDown={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 40 })
              }
              onMoveLeft={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 37 })
              }
              onMoveRight={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 39 })
              }
            />
          </motion.div>
        </div>
        {showModal && (
          <ShoveberryModal
            overlayColor={modalData.overlayColor}
            thumbnail={modalData.thumbnail}
            title={modalData.title}
            timeTaken={modalData.timeTaken}
            totalMoves={modalData.totalMoves}
            subTitle={modalData.subTitle}
            showPlayAgain={modalData.showPlayAgain}
            actionButtonText={modalData.actionButtonText}
            actionButtonRedirect={modalData.actionButtonRedirect}
            showTimeSection={modalData.showTimeSection}
            onSubmit={modalData.onSubmit}
          />
        )}
      </>
    );
  }
}
export default ShoveBerryHome;
